import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Base API URL from environment variables
const apiUrl = process.env.REACT_APP_API_URL;


// Thunk: Delete Agent by ID
export const deleteAgent = createAsyncThunk(
  "agents/deleteAgent",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${apiUrl}/GetAgents/${id}/`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return id; // Return the ID of the deleted agent
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || "Failed to delete agent");
    }
  }
);

// Define the initial state for the agents slice
const initialState = {
  agents: [],
  loading: false,
  error: null,
};

// Create a slice for managing agent state
const agentsSlice = createSlice({
  name: "agents",
  initialState,
  reducers: {
    // Optionally, you can define reducers to add, update, or manage agents
    setAgents(state, action) {
      state.agents = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteAgent.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAgent.fulfilled, (state, action) => {
        state.loading = false;
        // Remove the agent from the agents array by matching the ID
        state.agents = state.agents.filter(agent => agent.id !== action.payload);
      })
      .addCase(deleteAgent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions
export const { setAgents } = agentsSlice.actions;

// Export the reducer
export default agentsSlice.reducer;
